module.exports = __webpack_public_path__ + "img/IMG_1645_L_Foamcore_MockedUp.ba28416d.jpg";